export const ROUTES = {
  ONBOARDING: '/onboarding',
  JOIN: '/members/join',
  CREATEACCOUNT: '/members/create-account',
  RECOMMENDEDPROGRAM: '/recommended-program',
} as const;
